export default __webpack_public_path__ + "static/media/HP2.88279243.jpg";